<template>
    <div class="total-hiring-sources-content">
        <div class="main-title d-flex justify-content-between align-items-center">
            <h3>Employees Availability</h3>

            <select class="form-select form-control" aria-label="Default select example">
                <option selected>7 days</option>
                <option value="1">15 days</option>
                <option value="2">10 days</option>
                <option value="3">5 days</option>
            </select>
        </div>

        <div id="chart">
            <apexchart type="bar" height="250" :options="availabilityChart" :series="availability"></apexchart>
        </div>

        <div class="row">
            <div class="col-lg-3 col-sm-6">
                <div class="single-hiring border-style-4fcb8d">
                    <span class="title">UI/UX Design</span>
                    <h4>35% <span>(Avg)</span></h4>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-hiring border-style-1765fd">
                    <span class="title">Web Development</span>
                    <h4>45% <span>(Avg)</span></h4>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-hiring border-style-5c31d6">
                    <span class="title">App Development</span>
                    <h4>15% <span>(Avg)</span></h4>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-hiring border-style-fec107">
                    <span class="title">Product Manager</span>
                    <h4>25% <span>(Avg)</span></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmployeesAvailabilityChart',
    data: function() {
        return {
            availability: [{
                name: "UI/UX Design",
                data: [50, 30, 30, 50, 50, 43, 36],
            }, {
                name: "Web Development",
                data: [40, 30, 70, 80, 50, 50, 60],
            }, {
                name: "App Development",
                data: [50, 30, 30, 50, 50, 43, 36],
            }, {
                name: "Product Manager",
                data: [40, 30, 70, 80, 50, 70, 80],
            }],
            availabilityChart: {
                chart: {
                    height: 250,
                    type: "bar",
                    stacked: !0,
                    toolbar: {
                        show: !1,
                    },
                    zoom: {
                        enabled: !0,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "35%",
                        endingShape: "rounded",
                        borderRadius: 5,
                    },
                },
                dataLabels: {
                    enabled: !1,
                },
                xaxis: {
                    categories: ["SAT", "SUN", "MON", "TUE", "WED", "THU", "FRI"],
                    labels: {
                        style: {
                            colors: "#A9A9C8",
                        },
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: "#A9A9C8",
                        },
                    },
                },
                colors: ["#4FCB8D", "#1765FD", "#5C31D6", "#FEC107"],
                legend: { show: false },
                fill: { opacity: 1, },
            },
        }
    },
}
</script>

<style lang="scss">
.total-hiring-sources-content {
	background: #FFFFFF 0% 0% no-repeat padding-box;
	box-shadow: 0px 2px 15px #00000005;
	border: 1px solid #EBF1FF;
	border-radius: 30px;
	padding: 30px;
	padding-bottom: 0;
	margin-bottom: 24px;
	.apexcharts-legend.apexcharts-align-center.position-top {
		display: none;
	}
	.main-title {
		margin-bottom: 3px;
	}
}
.single-hiring {
	padding-left: 10px;
	margin-bottom: 30px;
	position: relative;
	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 2px;
		height: 100%;
		background-color: #1765fd;
		border-radius: 30px;
	}
	.title {
		font-size: 13px;
		font-weight: 500;
		letter-spacing: -0.26px;
		display: block;
		margin-bottom: 4px;
	}
	h4 {
		font-size: 14px;
		span {
			font-size: 11px;
			color: #BCC2CF;
			font-weight: 500;
		}
	}
	&.border-style-4fcb8d {
		&::before {
			background-color: #4fcb8d;
		}
	}
	&.border-style-1765fd {
		&::before {
			background-color: #1765fd;
		}
	}
	&.border-style-5c31d6 {
		&::before {
			background-color: #5c31d6;
		}
	}
	&.border-style-fec107 {
		&::before {
			background-color: #fec107;
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .total-hiring-sources-content{
        padding: 15px;
        .col-sm-6 {
            flex: 0 0 auto;
            width: 50%;
        }
    }
}

/* Min width 375px to Max width 767px */
@media only screen and (min-width: 375px) and (max-width: 575px) {
    .total-hiring-sources-content {
        .col-sm-6 {
            flex: 0 0 auto;
            width: 50%;
        }
    }
}

/* Min width 1200px to Max width 1320px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
    .single-hiring {
        .title {
            font-size: 11px;
        }
    }
}

/* Min width 1400px to Max width 1700px */
@media only screen and (min-width: 1400px) and (max-width: 1700px) {
    .total-hiring-sources-wrap {
        .col-xxl-8 {
            flex: 0 0 auto;
            width: 100%;
        }
        .col-xxl-4 {
            flex: 0 0 auto;
            width: 100%;
        }
    }
}
</style>